import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons"
import { Handle, Position } from "@xyflow/react";
import { useTranslation } from "react-i18next";

let defaultMenuItems = [
    { label: 'Step', value: 'step' },
    { label: 'Condition', value: 'condition' },
    { label: 'Notification', value: 'notification' },
    { label: 'end', value: 'end' }
]

const OutputNode = ({ data, id, position, draggable, selectable, type }) => {

    const { t } = useTranslation();

    return (
        <>
            {
                data.type === "approve" ?
                    <>
                        <Handle type="target" position={Position.Left} style={{ top: "50%" }} />
                        <Handle type="source" position={Position.Right} style={{ top: "52%" }} />

                        <div className="output-node">
                            <div className="node-icon approve">
                                <CheckCircleOutlined />
                            </div>
                            <div className="node-title">{t("Approved")}</div>
                        </div>
                    </>
                    :
                    <>
                        <Handle type="target" position={Position.Left} style={{ top: "48%" }} />
                        <Handle type="source" position={Position.Right} style={{ top: "52%" }} />
                        <div className="output-node">
                            <div className="node-icon reject">
                                <CloseCircleOutlined />
                            </div>
                            <div className="node-title">{t("Rejected")}</div>
                        </div>
                    </>
            }
        </>
    )

}

export default OutputNode